import { useMissingData } from "./useMissingData";

export const useUsPersonMissingFields = (
  verificationLevel: string
): string[] => {
  const data = useMissingData(verificationLevel) as any; // TODO(us person updates)

  return data?.profiles?.US?.requiredFields || [];
};
